/**
 * FAQ Accordion Frontend JavaScript
 * Handles GSAP animations for accordion functionality
 */

(function() {
    'use strict';

    // Wait for GSAP to be available
    function waitForGSAP() {
        return new Promise((resolve) => {
            if (typeof gsap !== 'undefined') {
                resolve();
            } else {
                const checkGSAP = setInterval(() => {
                    if (typeof gsap !== 'undefined') {
                        clearInterval(checkGSAP);
                        resolve();
                    }
                }, 100);
            }
        });
    }

    // Initialize FAQ Accordion functionality
    function initFAQAccordion() {
        const accordions = document.querySelectorAll('[data-accordion="faq"]');
        
        accordions.forEach((accordion) => {
            const items = accordion.querySelectorAll('[data-accordion-item]');
            let activeItem = null;

            // Add scroll animations for accordion items
            if (items.length > 0) {
                // Set initial state (invisible, 30px down)
                gsap.set(items, {
                    opacity: 0,
                    y: 30,
                });

                // Animate items in on scroll with stagger
                ScrollTrigger.batch(items, {
                    start: "top 95%",
                    end: "bottom 20%",
                    onEnter: (elements) => {
                        gsap.to(elements, {
                            opacity: 1,
                            y: 0,
                            duration: 0.8,
                            stagger: 0.2,
                            ease: "power2.out",
                        });
                    },
                });
            }

            items.forEach((item) => {
                const trigger = item.querySelector('[data-accordion-trigger]');
                const content = item.querySelector('[data-accordion-content]');
                const icon = item.querySelector('.faq-accordion__icon svg');
                
                if (!trigger || !content) return;

                // Set initial state
                gsap.set(content, {
                    height: 0,
                    overflow: 'hidden'
                });

                if (icon) {
                    gsap.set(icon, {
                        rotation: 180 // Start with arrow pointing down (closed state)
                    });
                }

                // Add click handler
                trigger.addEventListener('click', () => {
                    const isActive = item === activeItem;
                    
                    // Close currently active item if there is one
                    if (activeItem && activeItem !== item) {
                        closeAccordionItem(activeItem);
                    }

                    if (isActive) {
                        // Close this item
                        closeAccordionItem(item);
                        activeItem = null;
                    } else {
                        // Open this item
                        openAccordionItem(item);
                        activeItem = item;
                    }
                });
            });

            // Helper function to open accordion item
            function openAccordionItem(item) {
                const content = item.querySelector('[data-accordion-content]');
                const icon = item.querySelector('.faq-accordion__icon svg');
                
                if (content) {
                    // Get natural height
                    gsap.set(content, { height: 'auto' });
                    const height = content.offsetHeight;
                    gsap.set(content, { height: 0 });

                    // Animate to full height
                    gsap.to(content, {
                        height: height,
                        duration: 0.8,
                        ease: 'power2.out'
                    });
                }

                if (icon) {
                    // Rotate arrow to point up (open state) and change fill color
                    const iconPath = icon.querySelector('path');
                    gsap.to(icon, {
                        rotation: 0,
                        duration: 0.4,
                        ease: 'power2.out'
                    });
                    if (iconPath) {
                        gsap.to(iconPath, {
                            fill: '#60215F',
                            duration: 0.4,
                            ease: 'power2.out'
                        });
                    }
                }

                item.classList.add('is-open');
            }

            // Helper function to close accordion item
            function closeAccordionItem(item) {
                const content = item.querySelector('[data-accordion-content]');
                const icon = item.querySelector('.faq-accordion__icon svg');
                
                if (content) {
                    gsap.to(content, {
                        height: 0,
                        duration: 0.6,
                        ease: 'power2.inOut'
                    });
                }

                if (icon) {
                    // Rotate arrow to point down (closed state) and reset fill color
                    const iconPath = icon.querySelector('path');
                    gsap.to(icon, {
                        rotation: 180,
                        duration: 0.3,
                        ease: 'power2.inOut'
                    });
                    if (iconPath) {
                        gsap.to(iconPath, {
                            fill: '#1C1B1F',
                            duration: 0.3,
                            ease: 'power2.inOut'
                        });
                    }
                }

                item.classList.remove('is-open');
            }
        });
    }

    // Initialize when DOM is ready and GSAP is available
    function init() {
        waitForGSAP().then(() => {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', initFAQAccordion);
            } else {
                initFAQAccordion();
            }
        });
    }

    // Start initialization
    init();

})();
